// Version : 0.0.1
// Author : NANDHA
// LastEdit : KARTHEESWARAN
// MODFIED DATE:25-09-2025
// LAST ADD : CHANGE THE SERVICE NAME FROM CAPS TO SMALL

const BranchCollectionReportActionTypes = {
	/************** GET BRANCH REPORT LIST START ************** */
	GET_BRANCH_COLLECTION_REPORT_LIST_START: 'get_branch_collection_report_start',
	GET_BRANCH_COLLECTION_REPORT_LIST_SUCCESS: 'get_branch_collection_report_success',
	GET_BRANCH_COLLECTION_REPORT_LIST_FAILURE: 'get_branch_collection_report_failure',
	GET_BRANCH_COLLECTION_REPORT_LIST_RESPONSE_RESET: 'get_branch_collection_report_response_reset',
	GET_BRANCH_COLLECTION_REPORT_LIST_RESPONSE_CHANGED:
		'get_branch_collection_report_response_changed',
	/************** GET BRANCH REPORT LIST END ************** */
};
export default BranchCollectionReportActionTypes;
